import { render, staticRenderFns } from "./unfinished.vue?vue&type=template&id=a5cbbb96&scoped=true&"
import script from "./unfinished.vue?vue&type=script&lang=js&"
export * from "./unfinished.vue?vue&type=script&lang=js&"
import style0 from "./unfinished.vue?vue&type=style&index=0&id=a5cbbb96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cbbb96",
  null
  
)

export default component.exports